<div class="organization-trophies-overlay-header">
  <div class="organization-trophies-overlay-header__title"><brt-icon [icon]="'trophy'" [add-blur]="true"></brt-icon>
    {{"CLASS_DASHBOARD.NEW_WINDOW_TROPHIES" | translate}}</div>

  <div class="organization-trophies-overlay-header__hint-wrapper">
    <div class="organization-trophies-overlay-header__hint-circle"></div>

    <div class="organization-trophies-overlay-header__hint">{{completedTrophies}} von {{totalTrophies}} gesammelt</div>
  </div>

</div>
